<ng-container *ngIf="this.shareOption === 'edit' && userValidation$ | async as userValidation">
  <ng-container *ngIf="isOnActiveRoute('pattern') || isOnActiveRoute('causes')||isOnActiveRoute('editor')">
    <div class="button-wrapper" data-tour="step7">
      <button matTooltip="KI: Verbindungen zwischen selektierten Karten empfehlen" [matTooltipShowDelay]="300" data-tour="step7a" mat-icon-button [color]="getColor(recommendationTypes.EXISTING)" class="menu_icon" (click)="updateRecommendation(recommendationTypes.EXISTING)">
       <mat-icon class="material-symbols-outlined icon-display">cell_merge</mat-icon>
      </button>
     <button matTooltip="KI: Verbindungen zu neuen Karten empfehlen" [matTooltipShowDelay]="300" data-tour="step7b" mat-icon-button [color]="getColor(recommendationTypes.EXTENSION)" class="menu_icon" (click)="updateRecommendation(recommendationTypes.EXTENSION)">
       <mat-icon class="material-symbols-outlined icon-display">open_with</mat-icon>
      </button>
    </div>
    <!--
    <button mat-icon-button [color]="getColor(recommendationTypes.ALL)" class="menu_icon" (click)="updateRecommendation(recommendationTypes.ALL)">
      <mat-icon [inline]="true">online_prediction</mat-icon>
    </button>-->
    <button matTooltip="Ausgewählte Karten sortieren" [matTooltipShowDelay]="300" mat-icon-button [color]="getColor(recommendationTypes.SORTING)" class="menu_icon" (click)="updateRecommendationSorting()" [disabled]="!canSort()">
      <mat-icon class="icon-display" data-tour="step8">sort</mat-icon>
    </button>
  </ng-container>
</ng-container>


